import React, { FunctionComponent } from "react"
import { Button, Modal } from "react-bootstrap"
import EALAService from "../EALAService"
import "./Trees.css"

interface Props {
    manageParentState: Function
    treeStateID: number
}

const StateHierarchyTree: FunctionComponent<Props> = (props) => {

    const { manageParentState, treeStateID } = props
    const { lookupHashTableItem, getStateFromStateHierarchyTree } = EALAService
    const stateItem = getStateFromStateHierarchyTree(treeStateID)

    const buildStateIcon = () => {
        const bucketItem = lookupHashTableItem("stateIconTable", treeStateID)
        if (bucketItem) {
            return bucketItem[1].icon()
        }
        return
    }

    // console.log("HierarchyTree props", props)

    return (
        <div className="HierarchyTree">
            <Modal
                id="state-hierarchy-tree-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="HierarchyTreeModalHeader">
                        <div className="HierarchyTreeModalHeaderStateIcon">
                            {buildStateIcon()}
                        </div>
                        <p>{stateItem.state.StateName}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="HierarchyTreeModalBody">
                        {stateItem.profitCenters.map((profitCenterItem, i) =>
                            <div className="HierarchyTreeModalPCBranch" key={i}>
                                <div className="HierarchyTreeModalPCBranchTitle">
                                    <p className="HierarchyTreeModalPCBranchTitleText">{profitCenterItem.profitCenter.ProfitCenterLongDesc}</p>
                                    <span className="material-icons-outlined">turn_right</span>
                                </div>
                                {profitCenterItem.serviceAreas.map((serviceAreaItem, j) =>
                                    <div className="HierarchyTreeModalSABranch" key={j}>
                                        <div className="HierarchyTreeModalSABranchTitle">
                                            <p className="HierarchyTreeModalSABranchTitleText">{serviceAreaItem.ServiceAreaLongDesc}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="HierarchyTreeModalFooter">
                        <Button variant="secondary" onClick={() => manageParentState([{ key: "treeStateID", value: -1 }])}>Back</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default StateHierarchyTree